/**
 * Notifies EmailLayout when a child page is in narrow "exclusive"
 * mode (list hidden, email preview or compose owns the screen).
 * EmailLayout hides its redundant mobile toolbar when this is true.
 */

import { useEffect } from 'react'
import { useIsNarrowViewport } from '../../_internal/hooks/useIsNarrowViewport'
import { useUiStore } from '../../_internal/stores/uiStore'

export function useEmailMobileExclusiveChrome(active: boolean): void {
  const isNarrow = useIsNarrowViewport()
  const setExclusive = useUiStore((s) => s.setEmailMobileExclusiveView)

  useEffect(() => {
    if (!isNarrow) {
      setExclusive(false)
      return
    }
    setExclusive(active)
    return () => setExclusive(false)
  }, [active, isNarrow, setExclusive])
}
